import React from 'react';

const PageWrapper = ({ children }) => {
  return (
    <div style={{ width: '100%' }}>
      {children}
    </div>
  );
};

export default PageWrapper;
